import axios from "axios";
import { apiDefaults } from "../../index";

// Create separate instance to avoid default instance redirect on 401 error
export default axios.create(apiDefaults);
